export interface UserBugReport {
  reasonType: ReasonType;
  report: string;
  armyId: number | null;
  unitId: number | null;
  unitOptionId: number | null;
  value: string | null;
}

export enum ReasonType {
  MissingOption = 0,
  Cost = 1,
  Translate = 2,
  Other = 3,
}
